import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import AddVendorDialog from "./addVendorDialog/AddVendorDialog.vue";
import { VendorsTypes } from "@/enums/VendorsTypes";

export default {
  name: "VendorList",
  components: {
    ValidationObserver,
    ValidationProvider,
    AddVendorDialog,
    ConfirmDlg
  },
  data() {
    return {
      search: "",
      sortBy: "category",
      sortDesc: false,
      isManual: true,
      headers: [
        {
          text: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Name"],
          value: "name",
          sortable: false,
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Type"],
          value: "type",
          sortable: false,
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Category"],
          value: "category",
          sortable: false,
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Email"],
          value: "email",
          sortable: false,
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Phone"],
          value: "phoneNumber",
          sortable: false,
        },
        {
          text: "",
          value: "id",
          sortable: false,
        },
      ]
    }
  },
  computed: {
    currentFacility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    currentVendors() {
      return this.$store.state.additionalServicesModule.currentVendors
        .map(vendor => {
          const item = {...vendor}

          if(vendor?.type === VendorsTypes.Maintenance && vendor?.categoryId) {
            item.category = this.maintenanceCategories.filter(x => x.id === vendor.categoryId)[0]?.name;
          }

          if(!vendor?.type?.length) {
            item.type = VendorsTypes.Concierge;
          }

          return item;
        })
        .filter(vendor => {
          if (vendor?.type === VendorsTypes.Maintenance && !this.currentFacility?.maintenanceEnabled) {
            return false;
          }

          if (vendor?.type === VendorsTypes.Concierge && !this.currentFacility?.featureConcierge) {
            return false;
          }

          return true;
        })
    },
    maintenanceCategories() {
      return this.$store.state.maintenanceModule.maintenanceCategories;
    },
  },
  methods: {
    editVendor(row) {
      this.$refs.addVendorDialog.open(row);
    },
    deleteVendor(row) {
      (this.$refs.confirmationModal as any)
      .open(null, this.$i18n.messages[this.$i18n.locale]['VendorList.DeleteMessage'].replace('[name]', row.name), false)
      .then(response => {
        if (response && response.agree) {
          this.$store.dispatch("deleteVendor", row.id);
        }
      });
    },
    addNew() {
      this.$refs.addVendorDialog.open();
    },

  },
  created() {
    this.$store.dispatch("getVendors");
    this.$store.dispatch("getMaintenanceCategories");
  }
}